import { Component, computed, HostListener, Signal } from '@angular/core';
import { IAlbum, Lightbox } from './lightbox.service';

@Component({
  selector: 'app-lightbox',
  templateUrl: './lightbox.component.html',
  styleUrls: ['./lightbox.component.scss'],
  standalone: false
})
export class LightboxComponent {

  protected readonly current: Signal<IAlbum | undefined> =
    computed((): IAlbum | undefined => this.lightbox.album()[this.lightbox.index()]);

  protected readonly caption: Signal<string> = computed((): string => {
    const value: string | number | undefined = this.current()?.caption;

    return value === undefined || value === null ? '' : String(value);
  });

  constructor(protected lightbox: Lightbox) {}

  next(event?: Event): void {
    event?.stopPropagation();
    this.lightbox.next();
  }

  prev(event?: Event): void {
    event?.stopPropagation();
    this.lightbox.prev();
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (!this.lightbox.isOpen()) {
      return;
    }

    if (event.key === 'Escape') {
      this.lightbox.close();
    } else if (event.key === 'ArrowRight') {
      this.lightbox.next();
    } else if (event.key === 'ArrowLeft') {
      this.lightbox.prev();
    }
  }
}
